import { IApplicationState } from '../../types/redux';

export const selectAgreementPersonal = (state: IApplicationState) => state.legalCheck.agreementPersonal;
